import { apiBase } from '@/api/instance';

export const GetCategory = (query) => {
  return apiBase({
    url: query,
    method: 'get',
  });
};

